import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { animateScroll as scroll } from 'react-scroll';

import InnerWrapper from '../../global/InnerWrapper';
import Button from '../../global/Button';
import NavLink from '../../global/NavLink';

const Category = styled.p`
  color: ${p => p.theme.color.primary};
  font-family: ${p => p.theme.font.metaOt};
  font-size: 15px;
  letter-spacing: 0.02px;
  line-height: 28px;
  margin: 0;
  padding: 30px 0 0 0;
  text-transform: uppercase;
`;

const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 6px 6vw 0 0;
`;

const ProductTitle = styled.h1`
  color: ${p => p.theme.color.tertiary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 30px;
  font-weight: ${p => p.theme.fontWeight.regular};
  letter-spacing: 0.02px;
  margin: 0;
  padding: 0 10px 0 0;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
`;

const StyledInnerWrapper = styled(InnerWrapper)`
  height: inherit;
  position: relative;
`;

const StyledNavLink = styled(NavLink)`
  flex: 0 0 auto;
  width: 125px;
`;

const TopText = styled.p`
  align-self: center;
  color: ${p => p.theme.color.textSecondary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 18px;
  font-weight: ${p => p.theme.fontWeight.bold};
  line-height: 13px;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
`;

const ToTop = styled.div`
  background-color: ${p => p.theme.color.bgPrimary};
  cursor: pointer;
  display: flex;
  height: 56px;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 56px;
`;

const Wrapper = styled.div`
  background-color: ${p => p.theme.color.borderPrimaryOverlay};
  display: ${p => (p.show ? 'block' : 'none')};
  height: 133px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 25;
  @media (max-width: 600px) {
    display: none;
  }
`;

const CondensedHeader = ({ productCategory, productName, show }) => (
  <Wrapper show={show}>
    <ToTop onClick={scroll.scrollToTop}>
      <TopText>
        {'^'}
        <br />
        {'Top'}
      </TopText>
    </ToTop>
    <StyledInnerWrapper>
      <Category>{productCategory.name}</Category>
      <HorizontalWrapper>
        <ProductTitle>{productName}</ProductTitle>
        <StyledNavLink to="/locator">
          <Button full>Locator</Button>
        </StyledNavLink>
      </HorizontalWrapper>
    </StyledInnerWrapper>
  </Wrapper>
);

CondensedHeader.propTypes = {
  productCategory: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string
  }).isRequired,
  productName: PropTypes.string.isRequired,
  show: PropTypes.bool
};

export default CondensedHeader;
